import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { DRAWER_WIDTH } from "./constants";

export default makeStyles((theme) => ({
  drawer: {
    width: DRAWER_WIDTH,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    overflowX: "hidden",
    boxShadow: "none",
    backgroundColor: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
    "& div:last-child": {
      marginBottom: 0,
    },
  },
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.8)",
  },
  title: {
    fontSize: 28,
    lineHeight: "40px",
    maxWidth: "380px",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: "16px !important",
    paddingRight: theme.spacing(2),
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 48,
  },
  sectionHeaderTitle: {
    fontSize: 12,
    textTransform: "uppercase",
    letterSpacing: 2,
    color: grey[600],
  },
  bottomBar: {
    // In normal flow (flex column footer), not an absolute overlay — the
    // scrollable body shrinks to make room for it instead of hiding under it.
    flexShrink: 0,
    background: theme.palette.otherElementsBackground.main,
  },
  bottomBarContainer: {
    borderTop: `1px solid ${grey[300]}`,
    paddingTop: theme.spacing(4),
    display: "flex",
    justifyContent: "flex-end",
  },
  childrenContainer: {
    // Flex body: takes the space left by header / comments / footer and
    // scrolls internally. `minHeight: 0` is what lets a flex child shrink
    // below its content and scroll instead of overflowing the drawer.
    flex: "1 1 auto",
    minHeight: 0,
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    overflowX: "hidden",
    overflowY: "auto",
  },
  shrunkContainer: {
    maxHeight: "66%",
    overflowY: "auto",
  },
  draftTitle: {
    color: grey[500],
    fontSize: "28px",
    fontWeight: 500,
    letterSpacing: "2.8px",
    lineHeight: "40px",
  },
  loadingContainer: {
    opacity: 0.6,
    pointerEvents: "none",
  },
  error: { marginBottom: theme.spacing(2) },
}));
